import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from '@kontentino/ui';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons/faBuilding';
import { SocialLoginBusiness } from 'types/SocialLogin';
import HeapUtils from 'app/utils/heap';
import { getConnectNetwork } from 'app/modules/socialLogin/utils/connectTracking';

interface SelectBusinessPortfolioProps {
  businesses: SocialLoginBusiness[];
  pageType: number;
  onSelect: (business: SocialLoginBusiness) => void;
}

const SelectBusinessPortfolio = ({
  businesses,
  pageType,
  onSelect,
}: SelectBusinessPortfolioProps) => {
  const { t } = useTranslation();
  const hasTrackedListed = useRef(false);

  useEffect(() => {
    if (hasTrackedListed.current) {
      return;
    }

    hasTrackedListed.current = true;
    HeapUtils.track(HeapUtils.events.CONNECT_PORTFOLIOS_LISTED, {
      network: getConnectNetwork(pageType),
      portfolios_available_count: businesses.length,
    });
  }, [businesses.length, pageType]);

  return (
    <div className="tw-flex tw-flex-col tw-gap-3 tw-pb-6">
      <div className="tw-text-md tw-font-medium tw-text-grayscale-180">
        {t('newSocialMediaProfile.oboTokenType.selectBusinessHeading')}
      </div>
      {businesses.map((business) => (
        <Button
          key={business.id}
          variant="secondary"
          className="tw-w-full tw-justify-between"
          data-cy={`business-portfolio_item-button_${business.id}`}
          data-testid={`business-portfolio_${business.id}`}
          iconBefore={<Icon icon={faBuilding} />}
          onClick={() => onSelect(business)}
        >
          <span className="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2">
            <span>{business.name ?? business.id}</span>
            {business.partial && (
              <span
                data-testid={`business-portfolio_partial_${business.id}`}
                className="tw-text-xs tw-text-warning-100"
              >
                {t('newSocialMediaProfile.oboTokenType.partialBadge')}
              </span>
            )}
          </span>
        </Button>
      ))}
    </div>
  );
};

export default SelectBusinessPortfolio;
